<script>
import api from "@services/api";

export default {
  name: "TimelineGestao",
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    ehAdministrador() {
      return this.user && this.user.perfil === "Administrador";
    },
    opcoesMeses() {
      const nomesMeses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ];
      const hoje = new Date();
      const anoAtual = hoje.getFullYear();
      const mesAtualIdx = hoje.getMonth();

      const opcoes = [];
      // Gera opções dos últimos 24 meses até o final do ano corrente
      const dataFim = new Date(anoAtual, 11, 1);
      const dataInicio = new Date(anoAtual - 2, 0, 1);

      const cursor = new Date(dataFim.getFullYear(), dataFim.getMonth(), 1);
      while (cursor >= dataInicio) {
        const ano = cursor.getFullYear();
        const mes = cursor.getMonth();
        const valor = `${ano}-${String(mes + 1).padStart(2, "0")}`;
        const ehAtual = ano === anoAtual && mes === mesAtualIdx;
        const rotulo = `${nomesMeses[mes]}/${ano}${ehAtual ? " (Atual)" : ""}`;

        opcoes.push({
          value: valor,
          text: rotulo,
          ano,
          mes: mes + 1
        });

        cursor.setMonth(cursor.getMonth() - 1);
      }
      return opcoes;
    },
    anoMesAtualObj() {
      const hoje = new Date();
      let ano = hoje.getFullYear();
      let mes = hoje.getMonth() + 1;
      if (this.mesAnoSelecionado) {
        const partes = this.mesAnoSelecionado.split("-");
        if (partes.length === 2) {
          ano = parseInt(partes[0], 10) || ano;
          mes = parseInt(partes[1], 10) || mes;
        }
      }
      return { ano, mes };
    },
    opcoesSemanas() {
      const { ano, mes } = this.anoMesAtualObj;
      const ultimoDia = new Date(ano, mes, 0).getDate();
      const mesFmt = String(mes).padStart(2, "0");
      const opcoes = [];

      // Se houver um cliente específico selecionado, a opção "Mês Completo" fica disponível
      if (this.clienteSelecionadoId) {
        opcoes.push({
          value: null,
          text: `Mês Completo (01/${mesFmt} a ${ultimoDia}/${mesFmt})`
        });
      }

      const semanas = [
        { num: 1, inicio: 1, fim: 7 },
        { num: 2, inicio: 8, fim: 14 },
        { num: 3, inicio: 15, fim: 21 },
        { num: 4, inicio: 22, fim: 28 }
      ];
      if (ultimoDia > 28) {
        semanas.push({ num: 5, inicio: 29, fim: ultimoDia });
      }

      semanas.forEach(s => {
        const dIni = String(s.inicio).padStart(2, "0");
        const dFim = String(s.fim).padStart(2, "0");
        opcoes.push({
          value: s.num,
          text: `Semana ${s.num} (${dIni}/${mesFmt} a ${dFim}/${mesFmt})`
        });
      });

      return opcoes;
    },
    mesFormatadoTexto() {
      const nomesMeses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ];
      if (!this.mesAnoSelecionado) {
        return "Mês Atual";
      }
      const partes = this.mesAnoSelecionado.split("-");
      if (partes.length === 2) {
        const ano = parseInt(partes[0], 10);
        const mesIdx = parseInt(partes[1], 10) - 1;
        if (mesIdx >= 0 && mesIdx < 12) {
          return `${nomesMeses[mesIdx]}/${ano}`;
        }
      }
      return this.mesAnoSelecionado;
    },
    tituloPeriodoTexto() {
      const mesTxt = this.mesFormatadoTexto;
      if (this.semanaSelecionada) {
        return `Semana ${this.semanaSelecionada} (${mesTxt})`;
      }
      return mesTxt;
    },
    consultorSelecionadoObj() {
      if (!this.consultorSelecionadoNome) {
        return null;
      }
      if (this.sintesesIaPorConsultor[this.consultorSelecionadoNome]) {
        return this.sintesesIaPorConsultor[this.consultorSelecionadoNome];
      }
      if (this.timeline && this.timeline.resumosPorConsultor) {
        return (
          this.timeline.resumosPorConsultor.find(
            c => c.consultor === this.consultorSelecionadoNome
          ) || null
        );
      }
      return null;
    }
  },
  data() {
    const hoje = new Date();
    const anoAtual = hoje.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const mesAtualStr = String(mesAtual).padStart(2, "0");

    const diaHoje = hoje.getDate();
    let semPadrao = 1;
    if (diaHoje <= 7) semPadrao = 1;
    else if (diaHoje <= 14) semPadrao = 2;
    else if (diaHoje <= 21) semPadrao = 3;
    else if (diaHoje <= 28) semPadrao = 4;
    else semPadrao = 5;

    return {
      carregando: false,
      regerando: false,
      timeline: null,
      erro: "",
      expandido: false,
      clientesLista: [],
      clienteSelecionadoId: null,
      mesAnoSelecionado: `${anoAtual}-${mesAtualStr}`,
      semanaSelecionada: semPadrao,
      consultorSelecionadoNome: null,
      sintesesIaPorConsultor: {},
      carregandoSinteseConsultor: false
    };
  },
  mounted() {
    if (this.ehAdministrador) {
      this.carregarClientes();
    }
  },
  methods: {
    determinarSemanaPadrao(ano, mes) {
      const hoje = new Date();
      if (hoje.getFullYear() === ano && hoje.getMonth() + 1 === mes) {
        const dia = hoje.getDate();
        if (dia <= 7) return 1;
        if (dia <= 14) return 2;
        if (dia <= 21) return 3;
        if (dia <= 28) return 4;
        return 5;
      }
      return 1;
    },
    toggleExpandir() {
      this.expandido = !this.expandido;
      if (this.expandido && !this.timeline && !this.carregando) {
        this.carregarTimeline(false);
      }
    },
    async toggleConsultor(consultorNome) {
      if (this.consultorSelecionadoNome === consultorNome) {
        this.consultorSelecionadoNome = null;
        return;
      }
      this.consultorSelecionadoNome = consultorNome;

      if (this.sintesesIaPorConsultor[consultorNome]) {
        return;
      }

      this.carregandoSinteseConsultor = true;
      try {
        const { ano, mes } = this.obterAnoMesValores();
        const params = {
          consultor: consultorNome,
          ano,
          mes,
          semana: this.semanaSelecionada || undefined,
          clienteId: this.clienteSelecionadoId || undefined
        };

        const res = await api.get("crud/Expediente/sintese-consultor-ia", {
          params
        });
        if (res && res.data && res.data.data) {
          this.$set(this.sintesesIaPorConsultor, consultorNome, res.data.data);
        }
      } catch (err) {
        console.warn("Falha ao gerar síntese individual com IA:", err);
      } finally {
        this.carregandoSinteseConsultor = false;
      }
    },
    obterIniciais(nome) {
      if (!nome) return "CO";
      const partes = nome.trim().split(/\s+/);
      if (partes.length === 1) return partes[0].substring(0, 2).toUpperCase();
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    },
    obterCorAvatar(nome) {
      if (!nome) return "#389a78";
      const cores = [
        "#389a78", // Verde Avila
        "#2563eb", // Azul
        "#7c3aed", // Roxo
        "#0284c7", // Azul Celeste
        "#d97706", // Âmbar
        "#db2777", // Rosa
        "#059669", // Esmeralda
        "#4f46e5", // Índigo
        "#0d9488", // Teal
        "#ea580c" // Laranja
      ];
      let hash = 0;
      for (let i = 0; i < nome.length; i++) {
        hash = nome.charCodeAt(i) + ((hash << 5) - hash);
      }
      const idx = Math.abs(hash) % cores.length;
      return cores[idx];
    },
    onMesChange() {
      this.consultorSelecionadoNome = null;
      const { ano, mes } = this.anoMesAtualObj;
      if (!this.clienteSelecionadoId) {
        this.semanaSelecionada = this.determinarSemanaPadrao(ano, mes);
      }
      if (this.expandido) {
        this.carregarTimeline(false);
      } else {
        this.timeline = null;
      }
    },
    onClienteChange() {
      this.consultorSelecionadoNome = null;
      const { ano, mes } = this.anoMesAtualObj;
      if (this.clienteSelecionadoId) {
        // Para cliente específico, permite e define como padrão o Mês Completo
        this.semanaSelecionada = null;
      } else {
        // Para Todos os Clientes, exige selecionar uma semana do mês
        this.semanaSelecionada = this.determinarSemanaPadrao(ano, mes);
      }
      if (this.expandido) {
        this.carregarTimeline(false);
      } else {
        this.timeline = null;
      }
    },
    onSemanaChange() {
      this.consultorSelecionadoNome = null;
      if (this.expandido) {
        this.carregarTimeline(false);
      } else {
        this.timeline = null;
      }
    },
    regerarClick() {
      this.consultorSelecionadoNome = null;
      this.expandido = true;
      this.carregarTimeline(true);
    },
    async carregarClientes() {
      try {
        const response = await api.get("api/Tarefa/Clientes");
        if (response && response.data && response.data.data) {
          this.clientesLista = response.data.data;
        }
      } catch (err) {
        console.error("Erro ao carregar clientes:", err);
      }
    },
    async carregarTimeline(forcarRegerar = false) {
      if (forcarRegerar) {
        this.regerando = true;
      } else {
        this.carregando = true;
      }
      this.erro = "";
      this.consultorSelecionadoNome = null;

      try {
        const { ano, mes } = this.anoMesAtualObj;

        const params = {
          regerar: forcarRegerar,
          ano,
          mes,
          anoMes: this.mesAnoSelecionado
        };
        if (this.semanaSelecionada) {
          params.semana = this.semanaSelecionada;
        }
        if (this.clienteSelecionadoId) {
          params.clienteId = this.clienteSelecionadoId;
        }

        const response = await api.get("crud/Expediente/timeline-gestao", {
          params
        });

        if (
          response &&
          response.data &&
          response.data.status.toLowerCase() === "success"
        ) {
          this.timeline = response.data.data;
        } else {
          this.erro =
            (response && response.data && response.data.message) ||
            "Não foi possível carregar a evolução dos projetos agora.";
        }
      } catch (err) {
        this.erro =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          "Não foi possível carregar a evolução das atividades no momento.";
      } finally {
        this.carregando = false;
        this.regerando = false;
      }
    },
    tipoBadgeVariant(tipo) {
      const mapa = {
        entrega: "success",
        desenvolvimento: "primary",
        ajuste: "warning",
        reuniao: "purple"
      };
      return mapa[tipo] || "info";
    },
    tipoIconClass(tipo) {
      const mapa = {
        entrega: "fa fa-check-circle text-success",
        desenvolvimento: "fa fa-code text-primary",
        ajuste: "fa fa-wrench text-warning",
        reuniao: "fa fa-comments text-purple"
      };
      return mapa[tipo] || "fa fa-circle text-secondary";
    },
    tipoNome(tipo) {
      const mapa = {
        entrega: "Entrega / Conclusão",
        desenvolvimento: "Desenvolvimento",
        ajuste: "Ajuste / Refatoração",
        reuniao: "Alinhamento"
      };
      return mapa[tipo] || "Atividade";
    },
    obterListaConsultores() {
      const nomes = [];
      if (this.timeline) {
        if (Array.isArray(this.timeline.resumosPorConsultor)) {
          this.timeline.resumosPorConsultor.forEach(item => {
            if (item && item.consultor) nomes.push(item.consultor);
          });
        }
        if (Array.isArray(this.timeline.consultores)) {
          this.timeline.consultores.forEach(c => {
            if (c) nomes.push(c);
          });
        }
        if (Array.isArray(this.timeline.todosConsultores)) {
          this.timeline.todosConsultores.forEach(c => {
            if (c) nomes.push(c);
          });
        }
        if (Array.isArray(this.timeline.consultoresComPendencia)) {
          this.timeline.consultoresComPendencia.forEach(c => {
            if (c) nomes.push(c);
          });
        }
        if (Array.isArray(this.timeline.marcos)) {
          this.timeline.marcos.forEach(m => {
            if (m && Array.isArray(m.consultores)) {
              m.consultores.forEach(c => {
                if (c) nomes.push(c);
              });
            }
            if (m && Array.isArray(m.consultoresPendentes)) {
              m.consultoresPendentes.forEach(c => {
                if (c) nomes.push(c);
              });
            }
          });
        }
      }
      return nomes
        .map(n => String(n).trim())
        .filter(
          (nome, indice, lista) =>
            Boolean(nome) && lista.indexOf(nome) === indice
        )
        .sort((a, b) => b.length - a.length);
    },
    escaparHtml(texto) {
      return String(texto || "").replace(/[&<>"']/g, caractere => {
        const entidades = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        };
        return entidades[caractere];
      });
    },
    formatarResumoComConsultores(texto) {
      if (!texto) return "";
      const textoSeguro = this.escaparHtml(texto);
      const nomes = this.obterListaConsultores().map(nome =>
        this.escaparHtml(nome)
      );

      if (!nomes.length) return textoSeguro;

      const nomesEscapados = nomes.map(nome =>
        nome.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      );

      const textoSemStrong = textoSeguro.replace(/<\/?strong>/gi, "");
      const padrao = new RegExp(
        `(?<![a-zA-Z0-9_À-ÿ])(${nomesEscapados.join(
          "|"
        )})(?![a-zA-Z0-9_À-ÿ])(\\s*:)?`,
        "gi"
      );
      return textoSemStrong.replace(padrao, (match, p1, p2) => {
        return `<strong>${p1}</strong>${p2 || ""}`;
      });
    }
  }
};
</script>

<template>
  <div class="timeline-gestao-wrapper" v-if="ehAdministrador">
    <div class="card shadow-sm border-0 mb-4 timeline-card">
      <div class="card-header bg-white border-bottom py-3">
        <div
          class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center"
        >
          <!-- Lado Esquerdo: Título e Metadados -->
          <div
            class="d-flex align-items-start mb-2 mb-lg-0 mr-lg-3 flex-grow-1"
          >
            <div class="icon-circle mr-3 flex-shrink-0 mt-1">
              <i class="fa fa-line-chart text-primary font-20"></i>
            </div>
            <div>
              <h5 class="mb-1 font-weight-bold text-dark">
                Evolução das Atividades ({{ tituloPeriodoTexto }})
              </h5>
              <div class="text-muted small">
                <span v-if="!expandido && !timeline">
                  <i class="fa fa-chevron-circle-down mr-1 text-primary"></i>
                  Clique em <strong>Expandir</strong> para visualizar a evolução
                  das atividades de <strong>{{ tituloPeriodoTexto }}</strong
                  >.
                </span>
                <div
                  class="d-flex flex-wrap align-items-center"
                  v-else-if="timeline"
                >
                  <span class="mr-3">
                    <i class="fa fa-calendar mr-1 text-muted"></i>
                    <strong>Período:</strong> {{ timeline.periodo }}
                  </span>
                  <span
                    class="mr-3"
                    v-if="timeline.clientes && timeline.clientes.length"
                  >
                    <i class="fa fa-building-o mr-1 text-muted"></i>
                    <strong>Cliente:</strong> {{ timeline.clientes.join(", ") }}
                  </span>
                  <span
                    class="mr-3"
                    v-if="timeline.consultores && timeline.consultores.length"
                  >
                    <i class="fa fa-user-o mr-1 text-muted"></i>
                    <strong>Consultor:</strong>
                    <strong>{{ timeline.consultores.join(", ") }}</strong>
                  </span>
                  <span class="mr-3">
                    <i class="fa fa-file-text-o mr-1 text-muted"></i>
                    <strong>Expedientes:</strong>
                    {{ timeline.totalExpedientes }}
                  </span>
                  <span
                    class="mr-3 text-danger font-weight-bold"
                    v-if="
                      !clienteSelecionadoId &&
                        timeline.consultoresComPendencia &&
                        timeline.consultoresComPendencia.length
                    "
                  >
                    <i class="fa fa-exclamation-triangle mr-1"></i>
                    <strong>Pendência de cadastro:</strong>
                    <strong>{{
                      timeline.consultoresComPendencia.join(", ")
                    }}</strong>
                  </span>
                  <span
                    v-if="timeline.geradoEm"
                    class="badge badge-light border"
                  >
                    <span
                      :class="[
                        'dot-indicator',
                        timeline.veioDoCache ? 'bg-success' : 'bg-primary'
                      ]"
                    ></span>
                    {{
                      timeline.veioDoCache
                        ? "Cache SQLite diário"
                        : "Atualizado agora"
                    }}
                    ({{ timeline.geradoEm }})
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Lado Direito (Canto Superior Direito): Filtro Cliente + Filtro Mês + Filtro Semana + Regerar + Ocultar -->
          <div
            class="d-flex align-items-center flex-wrap flex-sm-nowrap ml-lg-auto justify-content-end align-self-stretch align-self-lg-center"
          >
            <!-- Filtro de Seleção de Cliente -->
            <div class="mr-2 my-1" style="min-width: 170px; max-width: 210px;">
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text bg-white text-muted border-right-0"
                    title="Filtrar por Cliente"
                  >
                    <i class="fa fa-filter"></i>
                  </span>
                </div>
                <b-form-select
                  v-model="clienteSelecionadoId"
                  size="sm"
                  class="form-control border-left-0 shadow-none font-weight-500 text-truncate"
                  @change="onClienteChange"
                  :disabled="carregando || regerando"
                >
                  <b-form-select-option :value="null">
                    Todos os Clientes
                  </b-form-select-option>
                  <b-form-select-option
                    v-for="cli in clientesLista"
                    :key="cli.id"
                    :value="cli.id"
                  >
                    {{ cli.denominacao || cli.nome }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </div>

            <!-- Filtro de Seleção de Mês -->
            <div class="mr-2 my-1" style="min-width: 160px; max-width: 195px;">
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text bg-white text-muted border-right-0"
                    title="Filtrar por Mês"
                  >
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                <b-form-select
                  v-model="mesAnoSelecionado"
                  size="sm"
                  class="form-control border-left-0 shadow-none font-weight-500 text-truncate"
                  @change="onMesChange"
                  :disabled="carregando || regerando"
                >
                  <b-form-select-option
                    v-for="m in opcoesMeses"
                    :key="m.value"
                    :value="m.value"
                  >
                    {{ m.text }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </div>

            <!-- Filtro de Seleção de Semana -->
            <div class="mr-2 my-1" style="min-width: 185px; max-width: 235px;">
              <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text bg-white text-muted border-right-0"
                    :title="
                      clienteSelecionadoId
                        ? 'Período (Mês Completo ou Semana)'
                        : 'Semana Obrigatória (Todos os Clientes)'
                    "
                  >
                    <i class="fa fa-clock-o"></i>
                  </span>
                </div>
                <b-form-select
                  v-model="semanaSelecionada"
                  size="sm"
                  class="form-control border-left-0 shadow-none font-weight-500 text-truncate"
                  @change="onSemanaChange"
                  :disabled="carregando || regerando"
                >
                  <b-form-select-option
                    v-for="s in opcoesSemanas"
                    :key="s.value === null ? 'mes-completo' : s.value"
                    :value="s.value"
                  >
                    {{ s.text }}
                  </b-form-select-option>
                </b-form-select>
              </div>
            </div>

            <!-- Botão Regerar Linha do Tempo -->
            <b-button
              variant="outline-primary"
              size="sm"
              class="mr-2 my-1 px-3 shadow-none font-weight-600 text-nowrap"
              :disabled="carregando || regerando"
              @click="regerarClick"
              title="Atualiza a análise com os expedientes mais recentes do banco"
            >
              <b-spinner v-if="regerando" small class="mr-1" />
              <i v-else class="fa fa-refresh mr-1"></i>
              {{ regerando ? "Regerando..." : "Regerar Linha do Tempo" }}
            </b-button>

            <!-- Botão Ocultar / Expandir -->
            <b-button
              variant="light"
              size="sm"
              class="border shadow-none my-1 text-nowrap"
              @click="toggleExpandir"
              :title="expandido ? 'Minimizar' : 'Expandir'"
            >
              <i
                :class="
                  expandido
                    ? 'fa fa-chevron-up mr-1'
                    : 'fa fa-chevron-down mr-1'
                "
              ></i>
              {{ expandido ? "Ocultar" : "Expandir" }}
            </b-button>
          </div>
        </div>
      </div>

      <b-collapse v-model="expandido">
        <div class="card-body p-4">
          <!-- Loading State -->
          <div v-if="carregando" class="text-center py-5">
            <b-spinner
              variant="primary"
              style="width: 2.5rem; height: 2.5rem;"
              class="mb-3"
            />
            <h6 class="text-dark font-weight-bold">
              Consolidando linha do tempo com Inteligência Artificial...
            </h6>
            <p class="text-muted small mb-0">
              Consultando expedientes recentes e sintetizando os marcos de
              desenvolvimento.
            </p>
          </div>

          <!-- Error State -->
          <div
            v-else-if="erro"
            class="alert alert-warning d-flex justify-content-between align-items-center mb-0"
          >
            <div><strong>Atenção:</strong> {{ erro }}</div>
            <b-button
              variant="outline-dark"
              size="sm"
              @click="carregarTimeline(false)"
            >
              Tentar novamente
            </b-button>
          </div>

          <!-- Content State -->
          <div v-else-if="timeline">
            <!-- Indicadores / KPIs -->
            <div class="row mb-4" v-if="timeline.indicadores">
              <div
                :class="
                  clienteSelecionadoId
                    ? 'col-md-4 col-sm-6 mb-2'
                    : 'col-md-3 col-sm-6 mb-2'
                "
              >
                <div
                  class="kpi-mini-card p-3 border rounded text-center bg-white shadow-2xs h-100"
                >
                  <div class="kpi-number text-primary font-weight-bold">
                    {{ timeline.indicadores.totalProjetosAtivos || 0 }}
                  </div>
                  <div class="kpi-label text-muted small">
                    Projetos / Tarefas
                  </div>
                </div>
              </div>
              <div
                :class="
                  clienteSelecionadoId
                    ? 'col-md-4 col-sm-6 mb-2'
                    : 'col-md-3 col-sm-6 mb-2'
                "
              >
                <div
                  class="kpi-mini-card p-3 border rounded text-center bg-white shadow-2xs h-100"
                >
                  <div class="kpi-number text-success font-weight-bold">
                    {{ timeline.indicadores.totalConsultoresAtivos || 0 }}
                  </div>
                  <div class="kpi-label text-muted small">
                    {{
                      clienteSelecionadoId
                        ? "Consultores no Cliente"
                        : "Consultores Ativos"
                    }}
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-sm-6 mb-2" v-if="!clienteSelecionadoId">
                <div
                  class="kpi-mini-card p-3 border rounded text-center bg-white shadow-2xs h-100"
                >
                  <div
                    :class="[
                      'kpi-number font-weight-bold',
                      timeline.indicadores.totalConsultoresComPendencias > 0
                        ? 'text-danger'
                        : 'text-muted'
                    ]"
                  >
                    {{
                      timeline.indicadores.totalConsultoresComPendencias || 0
                    }}
                  </div>
                  <div class="kpi-label text-muted small">Com Pendência</div>
                </div>
              </div>
              <div
                :class="
                  clienteSelecionadoId
                    ? 'col-md-4 col-sm-6 mb-2'
                    : 'col-md-3 col-sm-6 mb-2'
                "
              >
                <div
                  class="kpi-mini-card p-3 border rounded text-center bg-white shadow-2xs h-100 d-flex flex-column justify-content-center"
                >
                  <div class="kpi-label text-muted small mb-1">Ritmo Geral</div>
                  <strong class="text-dark font-13">
                    {{
                      timeline.indicadores.ritmoGeral ||
                        "Avançando com consistência"
                    }}
                  </strong>
                </div>
              </div>
            </div>

            <!-- Resumo Executivo Geral -->
            <div
              class="executive-summary-card p-3 mb-4 rounded border bg-light shadow-2xs"
              v-if="timeline.resumoGestor"
            >
              <div class="d-flex align-items-center mb-2">
                <i class="fa fa-newspaper-o text-primary mr-2 font-16"></i>
                <h6 class="font-weight-bold text-dark mb-0 font-14">
                  Síntese Executiva do Período
                </h6>
              </div>
              <p
                class="text-dark small mb-0"
                style="line-height: 1.6; white-space: pre-line;"
                v-html="formatarResumoComConsultores(timeline.resumoGestor)"
              ></p>
            </div>

            <!-- Seção: Síntese de Atuação por Consultor (UX Compacta com Avatar e "Ver mais") -->
            <div
              class="consultores-resumo-section mb-4"
              v-if="
                timeline.resumosPorConsultor &&
                  timeline.resumosPorConsultor.length
              "
            >
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <div class="d-flex align-items-center">
                  <h6
                    class="text-uppercase tracking-wider font-weight-bold text-muted mb-0 small"
                  >
                    <i class="fa fa-users text-primary mr-1"></i> Atuação por
                    Consultor
                  </h6>
                  <span class="badge badge-light border text-muted ml-2 small">
                    {{ timeline.resumosPorConsultor.length }} consultor(es)
                  </span>
                </div>
                <span
                  class="text-muted small font-12 d-none d-md-inline-block"
                  v-if="!consultorSelecionadoNome"
                >
                  <i class="fa fa-info-circle mr-1 text-primary"></i> Clique em
                  <strong>"Ver mais"</strong> para visualizar a síntese do
                  consultor.
                </span>
              </div>

              <!-- Barra de Consultores (Chips Compactos) -->
              <div
                class="consultants-chip-bar d-flex flex-wrap align-items-center"
              >
                <div
                  v-for="(consItem, cIdx) in timeline.resumosPorConsultor"
                  :key="cIdx"
                  class="consultant-pill-card mr-2 mb-2 d-flex align-items-center"
                  :class="{
                    'is-active': consultorSelecionadoNome === consItem.consultor
                  }"
                  @click="toggleConsultor(consItem.consultor)"
                  :title="
                    (consultorSelecionadoNome === consItem.consultor
                      ? 'Ocultar síntese de '
                      : 'Ver síntese de ') + consItem.consultor
                  "
                >
                  <!-- Avatar com Iniciais e Cor de Fundo Dinâmica -->
                  <div
                    class="consultant-avatar-circle flex-shrink-0 mr-2"
                    :style="{
                      backgroundColor: obterCorAvatar(consItem.consultor)
                    }"
                  >
                    <span>{{ obterIniciais(consItem.consultor) }}</span>
                  </div>

                  <!-- Nome do Consultor -->
                  <div class="consultant-pill-info mr-2">
                    <span class="consultant-name font-weight-bold text-dark">
                      {{ consItem.consultor }}
                    </span>
                    <span
                      v-if="consItem.totalLancamentos"
                      class="consultant-lanc-count text-muted ml-1"
                    >
                      ({{ consItem.totalLancamentos }})
                    </span>
                  </div>

                  <!-- Ação / Botão "Ver mais" / "Ocultar" -->
                  <div class="consultant-pill-action">
                    <button
                      type="button"
                      class="btn btn-xs btn-link p-0 text-decoration-none shadow-none"
                      :class="
                        consultorSelecionadoNome === consItem.consultor
                          ? 'text-primary font-weight-bold'
                          : 'text-muted'
                      "
                    >
                      <span class="action-label mr-1 font-11">
                        {{
                          consultorSelecionadoNome === consItem.consultor
                            ? "Ocultar"
                            : "Ver mais"
                        }}
                      </span>
                      <i
                        class="fa font-10"
                        :class="
                          consultorSelecionadoNome === consItem.consultor
                            ? 'fa-chevron-up text-primary'
                            : 'fa-chevron-down text-muted'
                        "
                      ></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Painel de Síntese Detalhada (Aberto apenas quando "Ver mais" for clicado) -->
              <b-collapse :visible="!!consultorSelecionadoObj">
                <div
                  class="consultant-detail-card card border-primary-subtle shadow-sm bg-white rounded p-3 mt-2 mb-2"
                  v-if="consultorSelecionadoObj"
                >
                  <div
                    class="d-flex align-items-start justify-content-between pb-2 mb-2 border-bottom"
                  >
                    <div class="d-flex align-items-center">
                      <div
                        class="consultant-avatar-circle flex-shrink-0 mr-2"
                        :style="{
                          backgroundColor: obterCorAvatar(
                            consultorSelecionadoObj.consultor
                          ),
                          width: '36px',
                          height: '36px',
                          fontSize: '13px'
                        }"
                      >
                        <span>{{
                          obterIniciais(consultorSelecionadoObj.consultor)
                        }}</span>
                      </div>
                      <div>
                        <div class="d-flex align-items-center flex-wrap">
                          <h6 class="mb-0 font-weight-bold text-dark mr-2">
                            {{ consultorSelecionadoObj.consultor }}
                          </h6>
                          <span
                            class="badge badge-primary-subtle border text-primary small font-weight-600 mr-2 my-1"
                          >
                            <i class="fa fa-magic mr-1"></i> Síntese de Atuação
                            com IA
                          </span>
                          <span
                            v-if="consultorSelecionadoObj.totalLancamentos"
                            class="badge badge-light border text-muted small my-1"
                          >
                            {{ consultorSelecionadoObj.totalLancamentos }}
                            apontamento(s) no período
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      type="button"
                      class="btn btn-sm btn-light border py-1 px-2 text-muted shadow-none"
                      @click.stop="consultorSelecionadoNome = null"
                      title="Fechar síntese"
                    >
                      <i class="fa fa-times mr-1"></i> Fechar
                    </button>
                  </div>

                  <!-- Conteúdo da Síntese com IA -->
                  <div class="consultant-synthesis-body py-1">
                    <div
                      v-if="carregandoSinteseConsultor"
                      class="py-3 text-center text-muted small"
                    >
                      <b-spinner
                        small
                        variant="primary"
                        class="mr-2"
                      ></b-spinner>
                      <span class="font-weight-500"
                        >Gerando síntese técnica detalhada com IA para
                        <strong>{{ consultorSelecionadoNome }}</strong
                        >...</span
                      >
                    </div>

                    <div v-else-if="consultorSelecionadoObj">
                      <p
                        class="text-dark small mb-3"
                        style="line-height: 1.6; white-space: pre-line; font-size: 0.9rem;"
                        v-html="
                          formatarResumoComConsultores(
                            consultorSelecionadoObj.resumo
                          )
                        "
                      ></p>

                      <!-- Principais Focos / Tags -->
                      <div
                        class="pt-2 border-top"
                        v-if="
                          consultorSelecionadoObj.principaisAtividades &&
                            consultorSelecionadoObj.principaisAtividades.length
                        "
                      >
                        <div
                          class="text-muted small font-weight-500 mb-1"
                          style="font-size: 0.78rem;"
                        >
                          <i class="fa fa-bullseye mr-1 text-primary"></i>
                          Principais Focos no Período:
                        </div>
                        <div class="d-flex flex-wrap">
                          <span
                            v-for="(ativ,
                            aIdx) in consultorSelecionadoObj.principaisAtividades"
                            :key="aIdx"
                            class="badge badge-light border text-primary mr-1 mb-1 small font-weight-500"
                          >
                            {{ ativ }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>

            <!-- Linha do Tempo Vertical -->
            <div class="timeline-section mt-4">
              <h6
                class="text-uppercase tracking-wider font-weight-bold text-muted mb-4 small"
              >
                <i class="fa fa-calendar-check-o mr-1 text-primary"></i> Linha
                Cronológica de Avanços Diários
              </h6>

              <div
                v-if="timeline.marcos && timeline.marcos.length"
                class="main-timeline"
              >
                <div
                  v-for="(marco, idx) in timeline.marcos"
                  :key="idx"
                  class="timeline-block"
                >
                  <div
                    class="timeline-icon"
                    :class="'icon-' + (marco.tipoMarco || 'desenvolvimento')"
                  >
                    <i :class="tipoIconClass(marco.tipoMarco)"></i>
                  </div>

                  <div
                    class="timeline-content-card border rounded p-3 bg-white shadow-2xs"
                  >
                    <div
                      class="d-flex flex-wrap justify-content-between align-items-center mb-2"
                    >
                      <div class="d-flex align-items-center flex-wrap">
                        <span
                          class="badge badge-primary px-2 py-1 mr-2 font-weight-bold"
                        >
                          {{ marco.data }}
                        </span>
                        <span
                          v-if="marco.diaSemana"
                          class="text-muted font-weight-500 mr-2 small"
                        >
                          ({{ marco.diaSemana }})
                        </span>
                        <span
                          :class="[
                            'badge mr-2',
                            'badge-' + tipoBadgeVariant(marco.tipoMarco)
                          ]"
                        >
                          {{ tipoNome(marco.tipoMarco) }}
                        </span>
                      </div>
                    </div>

                    <h6 class="font-weight-bold text-dark mb-1">
                      {{ marco.tituloDestaque }}
                    </h6>

                    <p
                      class="text-muted small mb-2"
                      style="white-space: pre-line; line-height: 1.5;"
                      v-html="formatarResumoComConsultores(marco.descricao)"
                    ></p>

                    <div class="pt-2 mt-2 border-top">
                      <!-- Informações de Cliente e Tarefa -->
                      <div class="d-flex flex-wrap align-items-center mb-2">
                        <div
                          class="mr-3 mb-1"
                          v-if="marco.clientes && marco.clientes.length"
                        >
                          <span class="text-muted small mr-1 font-weight-500"
                            ><i class="fa fa-building-o mr-1"></i>
                            Cliente:</span
                          >
                          <span
                            v-for="(cli, cIdx) in marco.clientes"
                            :key="cIdx"
                            class="badge badge-light border text-dark mr-1 small font-weight-normal"
                          >
                            {{ cli }}
                          </span>
                        </div>

                        <div
                          class="mr-3 mb-1"
                          v-if="
                            marco.projetosOuTarefas &&
                              marco.projetosOuTarefas.length
                          "
                        >
                          <span class="text-muted small mr-1 font-weight-500"
                            ><i class="fa fa-tasks mr-1"></i> Tarefa:</span
                          >
                          <span
                            v-for="(proj, pIdx) in marco.projetosOuTarefas"
                            :key="pIdx"
                            class="badge badge-light border text-dark mr-1 small font-weight-normal"
                          >
                            {{ proj }}
                          </span>
                        </div>
                      </div>

                      <!-- Consultores: Com Expediente vs Sem Expediente (Pendência em Vermelho) -->
                      <div
                        class="d-flex flex-wrap align-items-center pt-2 border-top-dashed"
                      >
                        <!-- Consultores que lançaram -->
                        <div
                          class="mr-3 my-1"
                          v-if="marco.consultores && marco.consultores.length"
                        >
                          <span class="text-success small mr-1 font-weight-600">
                            <i class="fa fa-check-circle mr-1"></i> Lançaram
                            expediente:
                          </span>
                          <span
                            v-for="(cons, csIdx) in marco.consultores"
                            :key="csIdx"
                            class="badge badge-success mr-1 small font-weight-bold"
                          >
                            {{ cons }}
                          </span>
                        </div>

                        <!-- Consultores com pendência de cadastro (Vermelho) - Apenas no filtro global -->
                        <div
                          class="mr-3 my-1"
                          v-if="
                            !clienteSelecionadoId &&
                              marco.consultoresPendentes &&
                              marco.consultoresPendentes.length
                          "
                        >
                          <span class="text-danger small mr-1 font-weight-bold">
                            <i class="fa fa-exclamation-triangle mr-1"></i>
                            Pendência de cadastro:
                          </span>
                          <span
                            v-for="(pend, pIdx) in marco.consultoresPendentes"
                            :key="pIdx"
                            class="badge badge-danger mr-1 small font-weight-bold"
                            title="Consultor sem expediente registrado nesta data"
                          >
                            <i class="fa fa-times mr-1"></i> {{ pend }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-else
                class="text-center py-4 text-muted small bg-light rounded border"
              >
                Nenhum marco relevante identificado para
                {{ tituloPeriodoTexto }}.
              </div>
            </div>

            <!-- Próximos Focos & Alertas de Melhorias -->
            <div
              class="row mt-4 pt-3 border-top"
              v-if="
                (timeline.proximosFocos && timeline.proximosFocos.length) ||
                  (timeline.alertasMelhoria && timeline.alertasMelhoria.length)
              "
            >
              <!-- Próximos Passos e Focos -->
              <div
                :class="
                  timeline.alertasMelhoria && timeline.alertasMelhoria.length
                    ? 'col-lg-6 mb-3'
                    : 'col-12 mb-3'
                "
                v-if="timeline.proximosFocos && timeline.proximosFocos.length"
              >
                <div class="card h-100 border-0 bg-gradient-foco p-3 rounded">
                  <h6 class="font-weight-bold text-dark mb-2">
                    <i class="fa fa-bullseye text-primary mr-1"></i> Próximos
                    Passos e Focos de Atenção:
                  </h6>
                  <div class="d-flex flex-column">
                    <div
                      v-for="(foco, fIdx) in timeline.proximosFocos"
                      :key="fIdx"
                      class="d-flex align-items-start small text-dark mb-2"
                    >
                      <i
                        class="fa fa-check text-primary font-weight-bold mr-2 mt-1"
                      ></i>
                      <span>{{ foco }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Alertas de Melhorias (Recomendações da IA) -->
              <div
                :class="
                  timeline.proximosFocos && timeline.proximosFocos.length
                    ? 'col-lg-6 mb-3'
                    : 'col-12 mb-3'
                "
                v-if="
                  timeline.alertasMelhoria && timeline.alertasMelhoria.length
                "
              >
                <div class="card h-100 border-0 bg-gradient-alerta p-3 rounded">
                  <h6 class="font-weight-bold text-dark mb-2">
                    <i class="fa fa-lightbulb-o text-warning mr-1"></i> Alertas
                    de Melhorias (Recomendações da IA):
                  </h6>
                  <div class="d-flex flex-column">
                    <div
                      v-for="(alerta, aIdx) in timeline.alertasMelhoria"
                      :key="aIdx"
                      class="d-flex align-items-start small text-dark mb-2"
                    >
                      <i
                        class="fa fa-exclamation-circle text-warning mr-2 mt-1"
                      ></i>
                      <span>{{ alerta }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<style scoped>
.timeline-card {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
}

.font-20 {
  font-size: 20px;
}

.font-16 {
  font-size: 16px;
}

.executive-box {
  background: #f8fafc;
  border-color: #e2e8f0 !important;
}

.executive-text {
  font-size: 0.95rem;
  line-height: 1.6;
}

.kpi-mini-card {
  border-radius: 8px;
  border-color: #e2e8f0 !important;
}

.kpi-number {
  font-size: 1.7rem;
  line-height: 1.2;
}

.kpi-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.kpi-status-box {
  border-color: #e2e8f0 !important;
}

.dot-indicator {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: middle;
}

/* Timeline Vertical Styling */
.main-timeline {
  position: relative;
  padding: 10px 0 10px 30px;
}

.main-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 14px;
  width: 3px;
  background: #cbd5e1;
  border-radius: 3px;
}

.timeline-block {
  position: relative;
  margin-bottom: 24px;
}

.timeline-block:last-child {
  margin-bottom: 0;
}

.timeline-icon {
  position: absolute;
  left: -30px;
  top: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.timeline-icon.icon-entrega {
  border-color: #10b981;
  background: #ecfdf5;
}

.timeline-icon.icon-desenvolvimento {
  border-color: #3b82f6;
  background: #eff6ff;
}

.timeline-icon.icon-ajuste {
  border-color: #f59e0b;
  background: #fffbeb;
}

.timeline-icon.icon-reuniao {
  border-color: #8b5cf6;
  background: #f5f3ff;
}

.timeline-content-card {
  border-color: #e2e8f0 !important;
  border-radius: 10px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.timeline-content-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

.bg-gradient-foco {
  background: #f8fafc;
  border: 1px solid #e2e8f0 !important;
}

.bg-gradient-alerta {
  background: #fffdf5;
  border: 1px solid #fef08a !important;
}

.shadow-2xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.border-top-dashed {
  border-top: 1px dashed #e2e8f0;
}

.badge-purple {
  background-color: #8b5cf6;
  color: #fff;
}

.text-purple {
  color: #8b5cf6;
}

.consultants-chip-bar {
  gap: 8px;
}

.consultant-pill-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  padding: 4px 12px 4px 6px;
  cursor: pointer;
  transition: all 0.18s ease-in-out;
  user-select: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.consultant-pill-card:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.consultant-pill-card.is-active {
  border-color: #389a78;
  background: #f0fdf4;
  box-shadow: 0 2px 8px rgba(56, 154, 120, 0.18);
}

.consultant-avatar-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.consultant-name {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

.consultant-lanc-count {
  font-size: 11px;
}

.consultant-pill-action .action-label {
  font-size: 11px;
}

.consultant-detail-card {
  border-radius: 10px;
  border: 1px solid rgba(56, 154, 120, 0.35) !important;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}

.badge-primary-subtle {
  background-color: #e6f4ea;
  color: #1e7e34;
  border-color: #c3e6cb !important;
}

.border-primary-subtle {
  border-color: #a7f3d0 !important;
}

.font-10 {
  font-size: 10px;
}

.font-11 {
  font-size: 11px;
}

.font-12 {
  font-size: 12px;
}
</style>
